<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
      novalidate
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.title.$invalid && $v.title.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />

                      <form-error
                        :model="$v.title"
                        :dirty="$v.$dirty"
                        label="Naziv *"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Nadredjena kompanija</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="parentCompanyId"
                      >
                        <option :value="null">Izaberite kompaniju</option>
                        <option
                          :value="company.id"
                          :key="company.id"
                          v-for="company in companies"
                        >
                          {{ company.title }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Opis</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        placeholder="Opis"
                        class="form-control form-control-modern"
                        v-model="description"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger':
                        $v.paymentTypes.$invalid && $v.paymentTypes.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Zadani način plaćanja *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div :class="{ has__error: $v.paymentTypes.$anyError }">
                        <treeselect
                          v-model="paymentTypes"
                          :multiple="true"
                          :options="paymentTypesArray"
                          :show-count="true"
                        />
                      </div>

                      <form-error
                        :model="$v.paymentTypes"
                        :dirty="$v.$dirty"
                        label="Način plaćanja *"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger':
                        $v.countryId.$invalid && $v.countryId.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Država *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="countryId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite državu"
                        :options="countries"
                        :default-options="countries"
                        :cache-options="false"
                        :async="true"
                        :load-options="loadCountries"
                        placeholder="Izaberite državu"
                        @select="getTowns"
                      />

                      <form-error
                        :model="$v.countryId"
                        :dirty="$v.$dirty"
                        label="Država *"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.townId.$invalid && $v.townId.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Grad *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="townId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite grad"
                        :load-options="loadTowns"
                        :cache-options="false"
                        :async="true"
                        :options="towns"
                        :default-options="towns"
                        placeholder="Izaberite grad"
                      />

                      <form-error
                        :model="$v.townId"
                        :dirty="$v.$dirty"
                        label="Grad *"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Komercijalista</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="commercialistId"
                      >
                        <option :value="null">Izaberite komercijalistu</option>
                        <option
                          :value="item.id"
                          :key="item.id"
                          v-for="item in commercialists"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.masterId.$invalid && $v.masterId.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Master kompanija *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="masterId"
                      >
                        <option :value="null">
                          Izaberite master kompaniju
                        </option>
                        <option
                          :value="item.id"
                          :key="item.id"
                          v-for="item in masterCompanies"
                        >
                          {{ item.title }}
                        </option>
                      </select>

                      <form-error
                        :model="$v.masterId"
                        :dirty="$v.$dirty"
                        label="Master kompanija *"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Besplatna dostava nakon iznosa</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Besplatna dostava nakon iznosa"
                        v-model="freeShippingForOrdersOver"
                      />
                    </div>
                  </div>
                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.code.$invalid && $v.code.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Kôd *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Kôd"
                        v-model="code"
                      />

                      <form-error
                        :model="$v.code"
                        :dirty="$v.$dirty"
                        label="Kôd *"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.address.$invalid && $v.address.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Adresa *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Adresa"
                        v-model="address"
                      />

                      <form-error
                        :model="$v.address"
                        :dirty="$v.$dirty"
                        label="Adresa *"
                      />
                    </div>
                  </div>

                  <!-- <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.discount.$invalid && $v.discount.$dirty }">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Discount</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        v-model="discount"
                      />
                    </div>
                  </div> -->

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.email.$invalid && $v.email.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >E-mail *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="email"
                        class="form-control form-control-modern"
                        placeholder="E-mail"
                        v-model="email"
                      />

                      <form-error
                        :model="$v.email"
                        :dirty="$v.$dirty"
                        label="E-mail *"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.phone.$invalid && $v.phone.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Telefon *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Telefon"
                        v-model="phone"
                      />

                      <form-error
                        :model="$v.phone"
                        :dirty="$v.$dirty"
                        label="Telefon *"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Fax</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Fax"
                        v-model="fax"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Web stranica</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="url"
                        class="form-control form-control-modern"
                        placeholder="Web stranica"
                        v-model="web"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger': $v.idNumber.$invalid && $v.idNumber.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Id broj
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Id broj"
                        v-model="idNumber"
                      />

                      <form-error
                        :model="$v.idNumber"
                        :dirty="$v.$dirty"
                        label="Id broj *"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Broj PDV-a</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Broj PDV-a"
                        v-model="vatNumber"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{
                      'has-danger':
                        $v.delayedPaymentInDays.$invalid &&
                        $v.delayedPaymentInDays.$dirty,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Rok plaćanja za kupca *</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Rok plaćanja za kupca"
                        v-model.number="delayedPaymentInDays"
                      />
                      <form-error
                        :model="$v.delayedPaymentInDays"
                        :dirty="$v.$dirty"
                        label="Rok plaćanja za kupca *"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Prikaz rabata?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="discountDataVisible"
                          id="discount-data-visible"
                        />
                        <label for="discount-data-visible"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Artikli uvijek vidljivi na webu?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="articleAlwaysVisibleOnWeb"
                          id="article-always-visible-on-web"
                        />
                        <label for="article-always-visible-on-web"></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika/logo</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        @change="handlePhotoUpload"
                        accept="image/*"
                      />
                      <span class="form-text">
                        Učitajte sliku rezolucije 400px x 320px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info" v-if="posterUrl">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">Company photo</h2>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <img :src="posterUrl" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="row action-buttons">
        <div
          class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
        >
          <router-link
            exact
            :to="{ name: 'Companies' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import helpers from '@/services/helpers';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddCompany',
  mixins: [translations],
  validations,
  components: { Treeselect, FormError },
  data() {
    return {
      title: null,
      description: null,
      code: null,
      address: null,
      countryId: null,
      commercialistId: null,
      townId: null,
      discount: 0,
      email: null,
      phone: null,
      fax: null,
      web: null,
      isVatPayer: false,
      idNumber: null,
      vatNumber: null,
      posterUrl: null,
      discountDataVisible: false,
      articleAlwaysVisibleOnWeb: false,
      delayedPaymentInDays: null,
      parentCompanyId: null,
      paymentTypes: [],
      masterId: null,
      freeShippingForOrdersOver: '',
    };
  },
  mounted() {
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getSimplifiedCompanies', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getMasterCompanies');
    this.$store.dispatch('getCommercialists');
  },
  computed: {
    paymentTypesArray() {
      return helpers.paymentTypesArray;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    commercialists() {
      return this.$store.getters.getCommercialists;
    },
    countries() {
      return this.$store.getters.getCountries.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => {
        return {
          id: item.id,
          label: item.title,
          ...item,
        };
      });
    },
    companies() {
      return this.$store.getters.getSimplifiedCompanies;
    },
    masterCompanies() {
      return this.$store.getters.getMasterCompanies;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const {
        title,
        description,
        code,
        address,
        townId,
        paymentTypes,
        // discount,
        email,
        phone,
        fax,
        web,
        isVatPayer,
        idNumber,
        vatNumber,
        commercialistId,
        discountDataVisible,
        articleAlwaysVisibleOnWeb,
        delayedPaymentInDays,
        parentCompanyId,
        masterId,
        freeShippingForOrdersOver,
      } = this;

      // formData.append('discount', discount);

      const payload = {
        title,
        description,
        code,
        address,
        townId,
        email,
        phone,
        fax,
        web,
        isVatPayer,
        idNumber,
        vatNumber,
        commercialistId,
        discountDataVisible,
        articleAlwaysVisibleOnWeb,
        delayedPaymentInDays,
        paymentTypes,
        parentCompanyId,
        masterId,
        freeShippingForOrdersOver,
      };

      if (this.$refs.photo.files[0]) {
        payload.image = {
          file: this.posterUrl.split(',')[1],
          fileName: this.$refs.photo.files[0].name,
        };
      }

      api
        .createCompany(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Companies' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    getTowns({ id }) {
      this.$store.dispatch('getTowns', { countryId: id });
      this.townId = null;
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.posterUrl = e.target.result;
      };
    },
    loadCountries({ callback, searchQuery }) {
      this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
    },
    loadTowns({ callback, searchQuery }) {
      this.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.countryId,
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
  },
};
</script>
